export default function SimpleToggle() {
    const toggleTargets = document.querySelectorAll("[data-toggle-class]");

    toggleTargets.forEach((elm) => {
        elm.addEventListener("click", () => {
            const data = elm.dataset;
            let targets = data.toggleTarget ? document.querySelectorAll(data.toggleTarget) : [elm];
            targets = data.toggleClosestTarget ? [elm.closest(data.toggleClosestTarget)] : targets;
            targets = targets.filter((target) => {
                return typeof target == "object";
            });

            targets.forEach((target) => {
                target.classList.toggle(data.toggleClass);
            });
        });
    });
}